<template>
  <div class="layout-content-list">
    <list-control listType="black" />
  </div>
</template>
<script>
import ListControl from '@/views/logistics/ListControl.vue';

export default {
  components: {
    ListControl
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
